import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  Card,
  CardBody,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  API_GMAIL,
  gAPI_Property_List_By_Group,
  dAPI_Delete_Ingetration,
} from '../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import Example from '../Example';
import { injectIntl } from 'react-intl';
import IntegrationInfo from './../Email/IntegrationInfo';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicketAlt } from '@fortawesome/free-solid-svg-icons';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
// import UnifiedInbox from './UnifiedInbox';
// import TicketThread from './TicketThread';
// import EmailForwarding from './EmailForwarding';
// import EmailSignature from './EmailSignature';
// import AutoReplies from './AutoReplies';
 import AutonomousReplies from './../Email/AutonomousReplies';
// import Topics from './Topics';
// import topic from '../../../../../../data/topic';
// import PreviewReply from './PreviewReply';
// import Features from './Features';
// import Settings from './Settings';
import Guardrails from './../Email/Guardrails';
import Subscriptions from './Subscriptions';
import { changeCurrentIntegrationTab } from '../../../../../../redux/actions';
// import DynamicFlow from './DynamicFlow';
function GmailIntegrationList({
  match,
  history,
  lang,
  propertyId,
  serviceProvider,
  currentIntegrationTab,
  changeCurrentIntegrationTab
}) {
  const integrationId = match.params.id;
  let [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [unifiedInboxVisible, setUnifiedInboxVisible] = useState(false);
  const [ticketThreadVisible, setTicketThreadVisible] = useState(false);
  const [features, setFeatures] = useState(false);
  const [emailForwardingVisible, setEmailForwardingVisible] = useState(false);
  const [emailSignature, setEmailSignature] = useState(false);
  const [autoReplies, setAutoReplies] = useState(false);
  const [guardrailsVisible, setGuardrailsVisible] = useState(false);
  const [autonoumsReplies, setAutonoumsReplies] = useState(false);
  const [addons, setAddons] = useState(false);
  const [topics, setTopics] = useState(false);
  const [isDynamicFlow, setIsDynamicFlow] = useState(false);
  const [preview, setPreview] = useState(false);
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [subscriptionsVisible, setSubscriptionsVisible] = useState(false);
  const [propertyDetails, setPropertyDetails] = useState();
  const [propertyList, setPropertyList] = useState([]);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };

  const showGuardrails = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setFeatures(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
    setGuardrailsVisible(true);
  };

  const showPreview = () => {
    setGuardrailsVisible(false);
    setIsDynamicFlow(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setFeatures(false);
    setPreview(true);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };

  const showTopics = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setGuardrailsVisible(false);
    setFeatures(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(true);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };

  const bussiness = () => {
    setIsDynamicFlow(false);
    setGuardrailsVisible(false);
    setPreview(false);
    setFeatures(false);
    setPropertyVisible(true);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };
  const unifiedInbox = () => {
    setIsDynamicFlow(false);
    setFeatures(false);
    setPreview(false);
    setGuardrailsVisible(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(true);
    setTicketThreadVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setEmailForwardingVisible(false);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };
  const ticketThread = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setFeatures(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(true);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setEmailForwardingVisible(false);
    setAddons(false);
    setGuardrailsVisible(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };
  const setEmailForwarding = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setFeatures(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailSignature(false);
    setGuardrailsVisible(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setEmailForwardingVisible(true);
    setAddons(false);
    setTopics(false);
    setFeatures(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };

  const handleFeatures = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setGuardrailsVisible(false);
    setPropertyVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setEmailForwardingVisible(false);
    setAddons(false);
    setTopics(false);
    setFeatures(true);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };

  const signature = () => {
    setIsDynamicFlow(false);
    setPreview(false);
    setPropertyVisible(false);
    setFeatures(false);
    setUnifiedInboxVisible(false);
    setGuardrailsVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(true);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };
  const replyThread = () => {
    setPropertyVisible(false);
    setIsDynamicFlow(false);
    setPreview(false);
    setFeatures(false);
    setGuardrailsVisible(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(true);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };
  const autoReplyThread = () => {
    setIsDynamicFlow(false);
    setPropertyVisible(false);
    setPreview(false);
    setFeatures(false);
    setUnifiedInboxVisible(false);
    setTicketThreadVisible(false);
    setGuardrailsVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(true);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };

  const handleAddons = () => {
    setPropertyVisible(false);
    setFeatures(false);
    setIsDynamicFlow(false);
    setUnifiedInboxVisible(false);
    setPreview(false);
    setTicketThreadVisible(false);
    setGuardrailsVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(true);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };

  const showDynamicFlow = () => {
    setPropertyVisible(false);
    setIsDynamicFlow(true);
    setFeatures(false);
    setUnifiedInboxVisible(false);
    setPreview(false);
    setTicketThreadVisible(false);
    setGuardrailsVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(false);
  };

  const showSettings = () => {
    setPropertyVisible(false);
    setIsDynamicFlow(false);
    setGuardrailsVisible(false);
    setFeatures(false);
    setUnifiedInboxVisible(false);
    setPreview(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(true);
    setSubscriptionsVisible(false);
  };

  const showSubscriptions = () => {
    setPropertyVisible(false);
    setIsDynamicFlow(false);
    setGuardrailsVisible(false);
    setFeatures(false);
    setUnifiedInboxVisible(false);
    setPreview(false);
    setTicketThreadVisible(false);
    setEmailForwardingVisible(false);
    setEmailSignature(false);
    setAutonoumsReplies(false);
    setAutoReplies(false);
    setAddons(false);
    setTopics(false);
    setSettingsVisible(false);
    setSubscriptionsVisible(true);
  };

  useEffect(() => {
    LoadIntegrationData();
    if(currentIntegrationTab && currentIntegrationTab === 'Subscriptions') {
      showSubscriptions();
      changeCurrentIntegrationTab('');
    }
  }, [integrationId]);
  const LoadIntegrationData = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_GMAIL}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setIntegration(res.data);
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
        }).then((json) => {
          setAllProperties(json.data);
          try {
            if (json.data.length > 0) {
              setPropertyDetails(
                json.data.filter((f) => res.data.properties.includes(f.id))[0]
              );
              setPropertyList(
                json.data.filter((f) => res.data.properties.includes(f.id))
              );
            }
          } catch { }
        });
      })
      .catch((err) => console.log('err', err));
  };
  const saveIntegration = (data) => {
    const { list, name, channelDetails } = data;
    if (channelDetails) {
      integration.channelDetails = channelDetails;
    }
    if (list) {
      integration.properties = list;
    }
    if (name) {
      integration.name = name;
    }
    AxiosAPI({
      method: 'put',
      url: `${API_GMAIL}/${integration.id}?group_id=${getGroupID()}`,
      data: integration,
    })
      .catch((err) => console.error(err))
      .then(() => {
        NotificationManager.success(
          '',
          'integration updated.',
          3000,
          null,
          null,
          'success'
        );
        setTimeout(() => {
          LoadIntegrationData();
          //window.location.reload();
        }, 500);
      });
  };

  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  /** FIXME: */
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integrationId}/?group_id=${getGroupID()}`,
    })
      .then((res) => console.log('res', res))
      .then(
        setTimeout(() => {
          history.push('/app/pages/integration/channels');
        }, 300)
      );
  };


  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/channels' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => bussiness()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Select Businesses
                          </p>
                          <p className="mb-4 text-small">
                            Select the businesses whose emails are processed
                            through this integration
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                 
                  <div
                    className={`mb-3 integration ${autonoumsReplies ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mail-reply`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => replyThread()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Autonomous Replies
                          </p>
                          <p className="mb-4 text-small">
                            Select the autonomy settings, the AI model, and the
                            prompt
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>                
                  {/* Guardrails menu entry */}
                  <div
                    className={`mb-3 integration ${guardrailsVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-shield`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showGuardrails()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Guardrails
                          </p>
                          <p className="mb-4 text-small">
                            Only send AI responses when safe, accurate, and compliant
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div className={`glyph-icon-min iconsminds-arrow-forward-2`} />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${subscriptionsVisible ? 'integration--active' : ''}`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon simple-icon-envelope`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => showSubscriptions()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Allowed Email Addresses
                          </p>
                          <p className="mb-4 text-small">
                            List email addresses to be added to this automation
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={showPreview}
                    >
                      Test Email Responses
                    </Button>
                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    integration={integration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                    channel={integration.channel}
                  />

                </Fragment>
              )}

              {/* {isDynamicFlow && (
                     <Fragment>
                       <DynamicFlow
                         lang={lang}
                         integration={integration}                         
                         saveIntegration={saveIntegration}
                         integrationId={integration.id}
                         channelDetails={integration.channelDetails}
                       />
                       {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> 
                 </Fragment>
                   )} */}
              {/* {unifiedInboxVisible && (
                <Fragment>
                  <UnifiedInbox
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )}
              {features && (
                <Fragment>
                  <Features
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )} */}
              {/* {preview && (
                <Fragment>
                  <PreviewReply
                    lang={lang}                    
                    propertyId={
                      integration.properties.length > 0
                        ? integration.properties[0]
                        : propertyId
                    }
                    propertyDetails={propertyDetails}
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )}
              {ticketThreadVisible && (
                <Fragment>
                  <TicketThread
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )}
              {topics && (
                <Fragment>
                  <Topics
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )} */}
              {/* {emailForwardingVisible && (
                <Fragment>
                  <EmailForwarding
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )} */}
              {/* {emailSignature && (
                <Fragment>
                  <EmailSignature
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )} */}
              {/* {addons && (
                <Fragment>
                  <Addons
                    integration={integration}
                    saveIntegration={saveIntegration}
                    allProperties={allProperties.filter(f => integration.properties.includes(f.id))}
                    integrationId={integration.id}
                    propertyId={
                      integration.properties.length > 0
                        ? integration.properties[0]
                        : propertyId
                    }
                    serviceProvider={serviceProvider}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )} */}
              {/* {autoReplies && (
                <Fragment>
                  <AutoReplies
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                  />
                  
                </Fragment>
              )} */}
              {autonoumsReplies && (
                <Fragment>
                  <AutonomousReplies
                    lang={lang}
                    integrationProperties={integration.properties}
                    integration={integration}
                    propertyList={propertyList}
                    allProperties={allProperties}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                    channel={integration.channel}
                  />
                  
                </Fragment>
              )}
              {/* {settingsVisible && (
                <Fragment>
                  <Settings
                    visible={settingsVisible}
                    toggle={() => setSettingsVisible(false)}
                    integrationId={integration.id}
                    saveIntegration={saveIntegration}
                    channelDetails={integration.channelDetails}
                    existingSettings={integration.channelDetails?.outlookSettings}
                  />
                </Fragment>
              )} */}
              {guardrailsVisible && (
                <Fragment>
                  <Guardrails
                    visible={guardrailsVisible}
                    integrationId={integration.id}
                    saveIntegration={saveIntegration}
                    channelDetails={integration.channelDetails}
                    existingSettings={integration.channelDetails?.outlookSettings} />
                </Fragment>
              )}
              {subscriptionsVisible && (
                <Fragment>
                  <Subscriptions
                    visible={subscriptionsVisible}
                    toggle={() => setSubscriptionsVisible(false)}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                    channelDetails={integration.channelDetails}
                    existingSubscriptions={integration.channelDetails?.subscriptions}
                  />
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null
      }
      {generateDeleteButton()}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, serviceProvider, locale, currentIntegrationTab   } = settings;
  const lang = locale;
  return {
    propertyId,
    lang,
    currentIntegrationTab,
    serviceProvider,
  };
};

export default injectIntl(connect(mapStateToProps, {changeCurrentIntegrationTab})(GmailIntegrationList));